export default function UserCreativesController(
  $state,
  CreativeService,
  CreativeGroupService,
  CreativeListService,
  CurrentUserService,
  DataService,
  DcoAssetsService,
  FlashService
) {
  const vm = this;

  vm.creativeService = CreativeService;
  vm.dataService = DataService;
  vm.handleClick = handleClick;
  vm.creativeListService = CreativeListService;
  vm.isActive = isActive;
  vm.activeType = 'creative';

  CreativeListService.initUserCreativesAndGroups().then(() => {
    if (CreativeService.isFromDco()) {
      fetchDcoAssets(CreativeService.creative);
    }
  });

  CurrentUserService.get().then(user => {
    vm.currentUser = user;
  });

  function isActive(creativeOrGroup) {
    let activeItem;

    // groups dont have an action
    if (creativeOrGroup.action && vm.activeType === 'creative') {
      activeItem = CreativeService.creative;
    } else if (vm.activeType === 'group') {
      activeItem = CreativeGroupService.group;
    }

    return (
      activeItem &&
      creativeOrGroup.id === activeItem.id &&
      creativeOrGroup.name === activeItem.name
    );
  }

  function handleClick(creative, event) {
    if (creative.action) {
      vm.activeType = 'creative';

      if (creative.dcoUrl) {
        fetchDcoAssets(creative);
      } else {
        CreativeService.setCreative(creative);
      }
    } else {
      // creative is actually a group in this case
      const group = creative;
      vm.activeType = 'group';
      CreativeGroupService.setCreativeGroup(group);

      // gross. rewrite me in react plz.
      if (
        event.target.matches('.ad-options-button') ||
        event.target.matches('.ad-option')
      ) {
        return;
      }

      $state.go('creativePreview.showPreviewGroup', { id: group.id });
    }
  }

  function fetchDcoAssets(creative) {
    DcoAssetsService.fetch(creative.dcoUrl)
      .then(responseCreative => {
        creative = Object.assign(creative, responseCreative);
        CreativeService.setCreative(creative);
      })
      .catch(() => {
        FlashService.push(
          'error',
          'The provided DCO URL responded with an error :('
        );
      });
  }
}

UserCreativesController.$inject = [
  '$state',
  'CreativeService',
  'CreativeGroupService',
  'CreativeListService',
  'CurrentUserService',
  'DataService',
  'DcoAssetsService',
  'FlashService'
];
